import { cva, type VariantProps } from 'class-variance-authority';

export const inputVariants = cva(
  'flex box-border transition-all heading-auto items-center disabled:cursor-not-allowed',
  {
    variants: {
      variant: {
        'white-outlined':
          'border outline-0 light:[&:not(.invalid)]:focus:border-blue-500 [&:not(.invalid)]:focus:border-blue-500 light:bg-white bg-[#161A20] light:placeholder-neutral-400 placeholder-neutral-100 light:text-neutral-500 text-white light:border-neutral-80 border-[#2B2E34] light:[&.invalid]:border-error [&.invalid]:border-error',
        'dark-outlined':
          'border border-[rgba(229,229,229,0.1)] bg-dark-gunmetal-400 placeholder-neutral-100 focus-visible:border-none light:border-neutral-80 light:bg-transparent light:placeholder-neutral-500 light:focus-visible:border-none',
        error: 'border-error',
      },
      size: {
        xs: 'is-tiny h-6 min-w-6 px-3 text-xs leading-normal rounded',
        sm: 'is-small h-8 min-w-8 px-4 text-sm leading-normal rounded-md',
        md: 'is-medium h-10 min-w-10 px-4 text-sm leading-normal rounded-lg',
        lg: 'is-large h-12 min-w-12 px-4 text-sm leading-normal rounded-[10px]',
        xl: 'is-extra-large h-14 min-w-14 px-4 text-base rounded-xl',
      },
    },
    defaultVariants: {},
  },
);

export type InputVariantProps = VariantProps<typeof inputVariants>;
